import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/ServiceCenter/ServiceCenterMonitoring.requests'
import {
    AvailabilityRequestData, OrderConfirmationAvailability,
} from '../orderConfirmation.types'

const useGetContainerAvailability = (
    params: AvailabilityRequestData,
) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useRequest<OrderConfirmationAvailability>({
        key: RequestKeys.getOrderConfirmationAvailability,
        params: {
            data: params,
        },
        requestFunc: RequestFn.getEntity(requests.getRequiredContainersAvailability),
        enabled: Boolean(params?.serviceCenter?.id),
    })

    return {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    }
}

export default useGetContainerAvailability
